import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "support-categories",
  "data-aos": "fade-up",
  "data-aos-once": "true",
  "data-aos-delay": "0"
}
const _hoisted_2 = { class: "support-categories__cards-container" }
const _hoisted_3 = {
  key: 0,
  class: "support-categories__back-button-container"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon-chevron-left support-categories__back-icon" }, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "support-categories__lookup-container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "support-categories__lookup-divider" }, null, -1 /* HOISTED */)
const _hoisted_7 = { class: "support-categories__search-wrap" }
const _hoisted_8 = { class: "support-categories__label" }
const _hoisted_9 = { class: "support-categories__search" }
const _hoisted_10 = { class: "support-categories__lookup-form-container" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "icon-chevron-right" }, null, -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "support-categories__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SupportCategoriesCard = _resolveComponent("SupportCategoriesCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (this.categoryStack.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.goBack())),
              class: "support-categories__back-button"
            }, _toDisplayString($data.translations?.GoBack), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _createVNode(_TransitionGroup, {
        name: "cards",
        tag: "div",
        class: "support-categories__cards-wrapper"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.currentCategory, (category) => {
            return (_openBlock(), _createElementBlock("div", {
              key: category.Id,
              class: "support-categories-card"
            }, [
              _createVNode(_component_SupportCategoriesCard, {
                displayTitle: category.DisplayTitle,
                imageUrl: category.CategoryCoverImageUrl,
                imageAlt: category.CategoryCoverImage,
                childCategories: category.ChildCategories,
                onEnterCategory: $options.enterCategory,
                currentCategory: $data.currentCategory,
                urlName: category.UrlName
              }, null, 8 /* PROPS */, ["displayTitle", "imageUrl", "imageAlt", "childCategories", "onEnterCategory", "currentCategory", "urlName"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString($data.translations?.IfYouKnowYourProductNumber), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("input", {
              id: "js-input-model-num",
              ref: "searchInput",
              placeholder: $data.translations?.ModelNumber,
              class: _normalizeClass(["support-categories__lookup-form", 
                                $data.supportCategoryError ? 'is-invalid' : ''
                            ]),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.checkValue && $options.checkValue(...args)))
            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_11),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.runLookup && $options.runLookup(...args))),
              class: "support-categories__lookup-button"
            }, _hoisted_13)
          ]),
          ($data.supportCategoryError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Please enter a search term "))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}